
import { datas } from "./datas"
const timerUrl = datas['url animation timer']

const SendStep = () => {
    return (
        <p className="send-step">
            <img src={timerUrl} alt="" />
        </p>
    )
}

export default SendStep